<template>
  <div class="hot-house-type" v-show="houseInfo && houseInfo.length">
    <div class="title">热销户型</div>
    <div class="house-type-wrap">
      <template v-for="(item, index) in houseInfo" >
        <house-type  @shapanDetail="shapanDetail" class="house-type" :class="{mr10: ((index+1) % 4)}" :key="index" v-if="index < 4 || isWatchMore " :info="item"></house-type>
      </template>
    </div>
    <div class="watch-more" v-if="isShow" @click="isWatchMore = !isWatchMore">{{watchMoreText}}</div>
    <a target="_blank" :href="shapanVrUrl1"><span id="tag1"></span></a>
  </div>
</template>
<script>
import houseType from './houseType.vue'
export default {
  name: 'hot-house-type',
  components: {
    houseType
  },
  props: {
    houseInfo: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    watchMoreText () {
      return this.isWatchMore ? '收起' : `查看所有户型（${this.houseInfo.length}）`
    },
    isShow () {
      return this.houseInfo.length > 4? true:false
    }
  },
  data () {
    return {
      isWatchMore: false,
      shapanVrUrl1: '',
    }
  },
  methods: {
    shapanDetail (data) {
      this.shapanVrUrl1 = data
      const tag1 = document.getElementById('tag1')
      setTimeout(() => {
        tag1.click()
      },500)
      // this.vrUrlDetail = data
      // this.dialogVrVisible = true
    },
  }
}
</script>
<style lang="scss" scoped>
.hot-house-type{
  margin-bottom: 60px;
  .title{
    @include font24(bold, #333333);
  }
  .house-type-wrap{
    margin-top: 20px;
    font-size: 0;
    .house-type{
      display: inline-block;
      margin-bottom: 20px;
    }
    .house-type:last-child{
      margin-right: 0;
    }
  }
  .watch-more{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #E6E6E6;
    margin-top: 4px;
    cursor: pointer;
  }
  .mr10{
    margin-right: 10px;
  }
}
// ::v-deep .el-image{
//   .el-image-viewer__wrapper {
//     top: 100px;
//     .el-image-viewer__canvas {
//     .el-image-viewer__img {
//       max-height: 70% !important;
//     }
//   }
//   }
// }
</style>
